// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import {
    loadContactReassigns,
    showDeleteContactReassignsPrompt,
    deletePromptReset,
    removeContactReassigns,
} from '../../redux/reducers/contactreassigns';
import List from '../../components/ContactReassigns/List';

import Loader from '../../components/Loader/Loader';
import DeleteContactReassignsModal from '../../components/ContactReassigns/DeleteModal';
import Pagination from '../../components/shared/Pagination';

import { colors } from '../../shared/styles';

const StyledFilter = styled.div`
    flex: 0 0 300px;
    background: ${colors.grey.default};
    color: ${colors.white};

    .btn {
        display: block;
        background: ${colors.orange.default};
        color: ${colors.white};
        border-radius: 4px;
        text-align: center;
        text-decoration: none;
        padding: 12px 0;
        width: 100%;
        border: 0;
    }

    .search-section {
        padding: 20px;
        border-bottom: solid 1px ${colors.grey.light};
    }

    .stats {
        display: block;
        text-align: center;
        font-size: 14px;
        font-stretch: normal;
        color: ${colors.darkBlue.default};
    }

    h2 {
        margin: 0;
        padding: 20px 30px 20px 30px;
        font-weight: lighter;
        border-bottom: solid 1px ${colors.grey.light};
    }
`;

const ContactReassignsWrapper = styled.div`
    display: flex;
    position: relative;

    .list {
        background: ${colors.white};
        flex-grow: 1;
    }

    .list-wrapper {
        background: ${colors.white};
        height: calc(100vh - 152px);
        overflow: hidden;
    }
`;

class ContactReassigns extends Component {
    onPageChange: Function;
    onDelete: Function;
    confirmDelete: Function;
    deletePromptReset: Function;
    refresh: Function;

    state = {
        refreshing: false,
    };

    constructor(props) {
        super(props);

        this.onPageChange = this.onPageChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.deletePromptReset = this.deletePromptReset.bind(this);
        this.refresh = this.refresh.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(loadContactReassigns(1));
    }

    onPageChange(pageNo) {
        this.props.dispatch(loadContactReassigns(pageNo));
    }

    onDelete(contactReAssign) {
        const contactReAssignName = `${contactReAssign.contactAssignFrom
            .contactForenames} ${contactReAssign.contactAssignFrom
            .contactSurname}`;

        this.props.dispatch(
            showDeleteContactReassignsPrompt(
                contactReAssign.contactReAssignId,
                contactReAssignName
            )
        );
    }

    confirmDelete() {
        const {
            dispatch,
            deletePrompt: { contactReAssignId, contactReAssignName },
        } = this.props;

        dispatch(
            removeContactReassigns(contactReAssignId, contactReAssignName)
        ).then(() => {
            this.refresh();
        });
    }

    deletePromptReset() {
        this.props.dispatch(deletePromptReset());
    }

    refresh() {
        this.setState({
            refreshing: true,
        });

        setTimeout(() => {
            this.props.dispatch(loadContactReassigns(1));
            this.setState({
                refreshing: false,
            });
        }, 500);
    }

    render() {
        const {
            contactReassigns,
            isFetching,
            deletePrompt,
            pagination,
            total,
            fetchingTime,
        } = this.props;
        const { refreshing } = this.state;

        return (
            <ContactReassignsWrapper>
                <DeleteContactReassignsModal
                    isOpen={deletePrompt.visible}
                    removing={deletePrompt.removing}
                    contactReAssignName={deletePrompt.contactReAssignName}
                    onCancel={this.deletePromptReset}
                    onConfirmDelete={this.confirmDelete}
                />
                <StyledFilter>
                    <div className="search-wrapper">
                        <h2>Contact Reassigns</h2>
                        <div className="search-section">
                            <Link className="btn" to="/contacts/reassigns/add">
                                Add New Contact Reassign
                            </Link>
                        </div>
                        <div className="search-section">
                            <span className="stats">
                                {total} result{total !== 1 ? 's' : ''} found in{' '}
                                {fetchingTime}ms
                            </span>
                        </div>
                    </div>
                </StyledFilter>
                <div className="list">
                    <div className="list-wrapper">
                        {(isFetching || !contactReassigns) &&
                            <Loader message="Loading contact reassigns, please wait..." />}
                        {refreshing &&
                            <Loader message="Refreshing, please wait..." />}
                        {!isFetching &&
                            contactReassigns &&
                            !refreshing &&
                            <List
                                contactReassigns={contactReassigns}
                                onDelete={this.onDelete}
                            />}
                    </div>
                    <Pagination
                        onPageChange={this.onPageChange}
                        pagination={pagination}
                    />
                </div>
            </ContactReassignsWrapper>
        );
    }
}

const mapStateToProps = state => {
    const list = state.contactreassigns.list;
    const remove = state.contactreassigns.remove;

    return {
        errorFetching: list.error,
        filter: list.filter,
        isFetching: list.fetching,
        contactReassigns: list.contactReAssign,
        deletePrompt: {
            contactReAssignId: remove.contactReAssignId,
            contactReAssignName: remove.contactReAssignName,
            removing: remove.removing,
            visible: Boolean(
                remove.contactReAssignId && remove.contactReAssignName
            ),
        },
        pagination: list.pagination,
        total: list.pagination.total,
        fetchingTime: list.fetchingTime,
    };
};

export default connect(mapStateToProps)(ContactReassigns);



// WEBPACK FOOTER //
// ./src/containers/ContactReassigns/ContactReassigns.js